'use client';

import { LoadingError } from '@govinity/ui/components/ui-custom/loading-error';
import { useRollbar } from '@rollbar/react';
import { useTranslations } from 'next-intl';
import { useEffect } from 'react';

import { useAuthStore } from '@/stores/authStore';
import { NavbarWrapper } from './navbar-wrapper';

export default function Error({ error }: { error: Error }) {
  const t = useTranslations('Error');
  const rollbar = useRollbar();
  const user = useAuthStore((state) => state.user);

  useEffect(() => {
    if (!rollbar.options.accessToken) {
      return;
    }

    rollbar.error(error);
  }, [error, rollbar]);

  return (
    <>
      <NavbarWrapper user={user} />
      <main id="main-content" className="mt-10 flex items-center justify-center">
        <LoadingError message={t('errorMessage')} />
      </main>
    </>
  );
}
